import { createSelector } from 'reselect';

import { initialState } from '../App/reducer';

const selectApp = (state) => state.app || initialState;

const selectIsAuthenticated = createSelector(selectApp, (appState) => appState.isAuthenticated);
const selectAccessToken = createSelector(selectApp, (appState) => appState.accessToken);
const selectRefreshToken = createSelector(selectApp, (appState) => appState.refreshToken);
const selectIdentity = createSelector(selectApp, (appState) => appState.identity);
const selectGoogleAccess = createSelector(selectApp, (appState) => appState.googleAccess);
const selectPopUp = createSelector(selectApp, (appState) => appState.popup);
const selectIsLoading = createSelector(selectApp, (appState) => appState.isLoading);

export {
  selectIsAuthenticated,
  selectAccessToken,
  selectRefreshToken,
  selectGoogleAccess,
  selectIdentity,
  selectPopUp,
  selectIsLoading,
};
